module.exports = __webpack_public_path__ + "img/graph-memory.f824546d.svg";